import { render, staticRenderFns } from "./table.vue?vue&type=template&id=6a5804c6&scoped=true&lang=html"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5804c6",
  null
  
)

export default component.exports